import { SET_NOT_AUTHORIZED_ALERT } from "../types/notAuthorizedAlert";

export const setNotAuthorizedAlertData = (payload) => (dispatch) => {
  dispatch({ type: SET_NOT_AUTHORIZED_ALERT, payload });
};
